var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2.5c-3.684 0-5.25 3.151-5.25 6-.956 0-1.75.777-1.75 1.714v8.572c0 .937.794 1.714 1.75 1.714h10.5c.956 0 1.75-.777 1.75-1.714v-8.572c0-.937-.794-1.714-1.75-1.714 0-2.849-1.566-6-5.25-6m0 1.451c2.67 0 3.626 2.598 3.626 4.549H7.404c0-1.951.926-4.549 3.596-4.549m-5.484 7.046a1 1 0 0 1 1-1h9.033a1 1 0 0 1 1 1v7.044a1 1 0 0 1-1 1H6.516a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgLockIcon;